import { render, staticRenderFns } from "./FiltersLoader.vue?vue&type=template&id=09745cfa&scoped=true&"
import script from "./FiltersLoader.vue?vue&type=script&lang=ts&"
export * from "./FiltersLoader.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersLoader.vue?vue&type=style&index=0&id=09745cfa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09745cfa",
  null
  
)

export default component.exports